export function initializeMobileFilterMenu() {
    const filterJobsButton = document.querySelector(".jobs-filter-button");
    const filterModal = document.querySelector(".jobs-filters-mobile");
    const pageOverlayFilters = document.querySelector(".page-overlay--filters");

    if (!filterJobsButton || !filterModal || !pageOverlayFilters) return;

    filterJobsButton.addEventListener("click", () => {
        filterJobsButton.classList.toggle("hamburger--active");
        filterModal.classList.toggle("jobs-filters-mobile--open");
        pageOverlayFilters.classList.toggle("page-overlay--active");
    });
}